<div class="relative" [ngClass]="Theme">        
    <svg-icon [src]="Path"></svg-icon>

    <!-- <ng-container *ngIf="Loading_sk">
        <app-skeletoons loading Theme="skeletoons-primary" Radius="0"></app-skeletoons>
    </ng-container> -->

</div>